var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAssetFacebookNormal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 300 300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1870",
    "data-name": "Path 1870",
    className: "cls-1",
    d: "M196.19,83s-16.88-2.74-19.68-2.74c-4.19,0-14.2,1.66-14.2,11.52v25.74h35L194,149.34l-31.7.54V254h-42.6V149.88l-21.32-.54L98.88,117H120.2c0-12.79-3.79-48.8,13.48-61.36,24.4-17.75,68-5.48,68-5.48Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssetFacebookNormal);
export default __webpack_public_path__ + "static/media/Asset_Facebook-normal.e53096f348c5ccbc4bfb75e9918d89a3.svg";
export { ForwardRef as ReactComponent };